module.exports = __webpack_public_path__ + "img/survey-selesai.bb433e21.png";